export function generateSecurePassword(length: number = 16): string {
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const symbols = '!@#$%^&*()_+-=[]{}|;:,.?';
  
  const allChars = uppercase + lowercase + numbers + symbols;
  let password = '';
  
  // Ensure at least one of each type
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];
  
  // Fill the rest randomly
  for (let i = password.length; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }
  
  // Shuffle the password
  return password.split('').sort(() => Math.random() - 0.5).join('');
}

export function calculatePasswordStrength(password: string): {
  score: number;
  feedback: string[];
} {
  const feedback: string[] = [];
  let score = 0;

  // Length checks with more granular scoring
  if (password.length >= 16) score += 3;
  else if (password.length >= 12) score += 2;
  else if (password.length >= 8) score += 1;
  else feedback.push('Le mot de passe doit contenir au moins 8 caractères');

  // Character variety checks
  if (/[A-Z]/.test(password)) score += 1;
  else feedback.push('Ajouter des lettres majuscules');
  
  if (/[a-z]/.test(password)) score += 1;
  else feedback.push('Ajouter des lettres minuscules');
  
  if (/[0-9]/.test(password)) score += 1;
  else feedback.push('Ajouter des chiffres');
  
  if (/[^A-Za-z0-9]/.test(password)) score += 1;
  else feedback.push('Ajouter des caractères spéciaux');

  // Pattern checks
  if (/(.)\1{2,}/.test(password)) {
    score -= 1;
    feedback.push('Éviter les caractères répétitifs');
  }

  if (/^[A-Za-z]+$/.test(password) || /^[0-9]+$/.test(password)) {
    score -= 1;
    feedback.push('Utiliser une combinaison de différents types de caractères');
  }

  // Normalize score to be between 0 and 4
  score = Math.max(0, Math.min(4, score));

  return {
    score,
    feedback: score < 3 ? feedback : []
  };
}